<script setup lang="ts">
import { computed } from 'vue'

import type { FeedPreview } from '../../models/product.types'
import { displayColumn } from '../../service/categoryMapping'

import { useReportCellFormatter, type ReportColumn } from '@/features/reports'
import { DataTable, type TableColumn } from '@/shared/ui'

const props = defineProps<{ preview: FeedPreview; ariaLabel: string }>()
const { formatCell } = useReportCellFormatter()
const reportColumns = computed<ReportColumn[]>(() =>
  props.preview.columns.map((field) => ({ field, header: displayColumn(field) })),
)
const columns = computed<TableColumn<Record<string, unknown>>[]>(() =>
  reportColumns.value.map(({ field, header }) => ({ field, header })),
)
const rows = computed(() =>
  props.preview.rows.map((row) =>
    Object.fromEntries(
      reportColumns.value.map((column) => [column.field, formatCell(row[column.field], column)]),
    ),
  ),
)
</script>

<template>
  <DataTable
    :rows="rows"
    :columns="columns"
    v-bind="{ ariaLabel }"
    max-height="22rem"
    :interactive-rows="false"
  />
</template>
